import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"pencil\"><path d=\"M14.487 1.513a1.75 1.75 0 0 0-2.474 0l-.772.771 2.475 2.475.771-.772a1.75 1.75 0 0 0 0-2.474ZM13.009 5.466l-2.475-2.475-8.1 8.1a3.5 3.5 0 0 0-.88 1.476l-.533 1.79a.5.5 0 0 0 .622.622l1.79-.533a3.5 3.5 0 0 0 1.475-.88l8.1-8.1Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol